var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('div',{staticClass:"BadgeHeight ml-10",staticStyle:{"margin-bottom":"-7px"}},[_vm._t("badge")],2),_c('div',[_c('span',{staticClass:"Plan text-16 font-weight-thin",class:_vm.sum_color + '--text'},[_vm._v(" "+_vm._s(_vm._f("money")(_vm.sum))+" ")]),_c('span',{staticClass:"grey4--text"},[_vm._v("₽")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }